import React from "react";
import { colors } from "../styles/colors";

type PageHeaderProps = {
  title: string;
  subtitle?: string;
  right?: React.ReactNode;
};

export default function PageHeader({ title, subtitle, right }: PageHeaderProps) {
  return (
    <div
      className="rounded-2xl bg-white px-5 py-4 shadow-sm"
      style={{ border: `1px solid ${colors.borderLight}` }}
    >
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <h1 className="m-0 text-[18px] font-bold md:text-[22px]" style={{ color: colors.textPrimary }}>
            {title}
          </h1>
          {subtitle && (
            <p className="m-0 mt-1 text-[13px]" style={{ color: colors.textTertiary }}>
              {subtitle}
            </p>
          )}
        </div>
        {right && <div className="flex w-full flex-wrap items-center gap-3 sm:w-auto">{right}</div>}
      </div>
    </div>
  );
}
